import { Module, Action, getModule } from 'vuex-module-decorators';

import store from '@/store';
import PageBaseModule from '@/store/page';
import PageEntity from '@/store/pageEntity';
import ResponseHandlerModule from '@/store/modules/responseHandler';

import { getList } from '@/api/crud';

import { Pages } from '@/models/pages';

export const MODULE_NAME = Pages.moduleName;

@Module({ dynamic: true, store, name: MODULE_NAME, namespaced: true })
class PagesModule extends PageBaseModule {

    constructor(module: PagesModule) {
        super(module);

        const page = new PageEntity();
        page.setTitle(Pages.listTitle);
        page.setTitleAdd(Pages.createTitle);
        page.values.actionPagination = 'pages/updatePage';
        page.values.actionPageAmountItems = 'pages/updatePageAmountItems';
        page.values.pageAmountItems = 50;

        this.pageSettings = page.values;
        this.pageSettings.routeName = `${Pages.moduleName}_edit`;
        this.pageSettings.routeParam = `${Pages.moduleName}Id`;
    }

    @Action({ rawError: true })
    async init() {
        await this.getList();
    }

    @Action({ rawError: true })
    async getList() {
        try {
            const sort = await this.getSortForRequest();
            const result = await getList(
                Pages.apiPrefix,
                {
                    page: this.pageSettings.pageCurrent,
                    items: this.pageSettings.pageAmountItems,
                },
                sort
            );

            await this.context.dispatch('setList', result.table);

        }  catch (clientError: any) {
            const error = clientError.response.data;

            ResponseHandlerModule.showNotify({ message: error.message, type: 'fail' });

            await this.context.dispatch('updatePage', 1);
        }
    }
}

export default getModule(PagesModule);
